import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TagsSelectionModalWrapperComponent} from 'fuse-core/components/tags-selection/tags-selection-modal-wrapper/tags-selection-modal-wrapper.component';
import {FuseSharedModule} from 'fuse-core/shared.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatToolbarModule } from '@angular/material/toolbar';
import {TranslateModule} from '@ngx-translate/core';
import { TagsSelectionCoreComponent } from './tags-selection-core/tags-selection-core.component';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatIconModule,
        MatToolbarModule,
        FuseSharedModule,
        MatSelectModule,
        MatTableModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatDialogModule
    ],
    declarations: [TagsSelectionModalWrapperComponent, TagsSelectionCoreComponent],
    exports: [
        TagsSelectionCoreComponent
    ]
})
export class TagsModule { }
